<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/configuration")
          i.fa.fa-cogs
          span.ml-1 {{ $t("ui.configuration") }}
      b-breadcrumb-item
        router-link(to="/configuration/sbobot")
          i.fa.fa-robot
          span.ml-1 {{ $t("ui.sbo_bot") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-6.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required autofocus type="text" v-model="botSearch" :placeholder="$t('message.search_by_id_name')")
                div.col-md-1.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $t("ui.id") }}
                    b-form-radio(value="name") {{ $t("ui.name") }}
          div.row
            div.col-md-12
              b-button(v-b-modal.addBot type="button" variant="primary" size="sm")
                i.fa.fa-plus
                span {{ $t("ui.combine.add_bot") }}
        div.card-body.p-1.clusterize
          div.clusterize-scroll
            table.tablex(style="width: auto;" v-columns-resizable)
              thead
                tr
                  th.sticky-position
                    span {{ $t('ui.id') }}
                  th.sticky-position
                    span {{ $tc('ui.providers', 1) }}
                  th.text-center.sticky-position(width=100)
                    span {{ $t("ui.action") }}
                  th.text-center.sticky-position(width=100 style="z-index: 10;")
                    span {{ $t("ui.time_sync") }}
                  th.sticky-position
                    span {{ $t('ui.name') }}
                  th.sticky-position(width=150 style="z-index: 10;")
                    span {{ $t('ui.login') }}
                  th.sticky-position
                    span {{ $t('ui.remark') }}
                  th.text-center.sticky-position(width=100 style="z-index: 10;")
                    span {{ $t("ui.disabled") }}
                  th.text-right.sticky-position(width=200)
                    span {{ $t("ui.created_on") }}
              tbody.clusterize-content
                tr(v-for="(item, index) in filteredBotList")
                  td
                    span {{ item.bot_id }}
                  td
                    span {{ item.provider_id }}
                  td.actions
                    span
                      a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                    span
                      a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                    span
                      a.fa.fa-cube.text-info(href="#" @click="onAssignLogin(item)" :title="$t('ui.combine.assign_bot_login')")
                    span
                      a.fa.fa-server.text-info(href="#" @click="onAssignProxy(item)" :title="$t('ui.combine.assign_bot_proxy')")
                  td
                    select(@change="changedTimeSync(item, $event)" :value="item.time_sync")
                      option(v-for="timeSyncInfo in timeSyncList" v-bind:value="timeSyncInfo.value")
                        | {{ timeSyncInfo.text }}
                  td
                    span {{ item.bot_name }}
                  td
                    b-form-select(@change="changedLoginId(item, $event, item.login_id)" :value="item.login_id" style="height: 20.5px!important;" :class="item.bot_id")
                      option(v-for="info in getLoginList(item)" :value="info.value") {{ info.text }}
                  td
                    span {{ item.remark }}
                  td.actions
                    div.d-flex.justify-content-center.align-items-center
                      label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        input.switch-input(type="checkbox" v-model="item.bot_disabled" @change="changedDisable(item, $event)")
                        span.switch-slider(:data-checked='on' :data-unchecked='off')
                  td.text-right
                    span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
    addbot(:providerID="providerID" @clicked="addBot" @failed="handleFailed")
    editbot(ref="editbot" :botId="editSelectedId" :botName="editSelectedName" :providerID="editSelectedProviderID" :remark="editSelectedRemark" @clicked="editBot" @failed="handleFailed")
    deletebot(ref="deletebot" :botId="deleteSelectedId" :botName="deleteSelectedName" :providerID="deleteSelectedProviderID" @clicked="deleteBot" @failed="handleFailed")
    assignbotlogin(ref="assignbotlogin" :botId="editSelectedId" :providerID="editSelectedProviderID" @clicked="assignBotLogin" @vip="vipBotLogin" @failed="handleFailed")
    assignbotproxy(ref="assignbotproxy" :botId="editSelectedId" :providerID="editSelectedProviderID" @clicked="assignBotProxy" @failed="handleFailed")
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

import addbot from "@/components/bot/addBot.vue";
import editbot from "@/components/bot/editBot.vue";
import deletebot from "@/components/bot/deleteBot.vue";
import assignbotlogin from "@/components/bot/assignBotLogin.vue";
import assignbotproxy from "@/components/bot/assignBotProxy.vue";

import $ from 'jquery';


export default {
  components: {
    addbot,
    editbot,
    deletebot,
    assignbotlogin,
    assignbotproxy,
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    filterBy: "id",
    providerList: [],
    providerID: "SBO",
    botList: [],
    timeSyncList: [],
    botSearch: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedId: "",
    editSelectedName: "",
    editSelectedProviderID: "",
    editSelectedRemark: "",
    deleteSelectedId: "",
    deleteSelectedName: "",
    deleteSelectedProviderID: "",
    freeLoginList: [],
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredBotList() {
      return this.botList.filter(item => {
        if (this.filterBy == "id") {
          return item.bot_id.toLowerCase().indexOf(this.botSearch.toLowerCase()) > -1 && item.provider_id.toLowerCase().indexOf(this.providerID.toLowerCase()) > -1;
        } else if (this.filterBy == "name") {
          return item.bot_name.toLowerCase().indexOf(this.botSearch.toLowerCase()) > -1 && item.provider_id.toLowerCase().indexOf(this.providerID.toLowerCase()) > -1;
        }
      });
    }
  },
  mounted: function() {
    this.getTimeSyncList();
    this.getBotList();
  },
  methods: {
    getTimeSyncList: function() {
      for (var i = 0; i <= 60; i++) {
        this.timeSyncList.push({
          value: i,
          text: i
        });
      }
    },
    getBotList: function() {
      this.botList = [];
      this.freeLoginList = [];

      let url = config.botListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.bot,
        bot_id: "",
        bot_name: "",
        provider_id: this.providerID
      };

      // if (this.filterBy == "id") {
      //   json.bot_id = this.botSearch;
      // } else {
      //   json.bot_name = this.botSearch;
      // }

      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.bot)
                  this.botList = response.data.ds.bot;

                console.log(this.botList);

                if (response.data.ds.freelogin)
                  this.freeLoginList = response.data.ds.freelogin;
                // this.botList = response.data.tbl_bot_list;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLoginList(item) {
      var list = [];
      var arr = [];
      var freeList = this.freeLoginList;

      if (item.login_id_str != null && item.login_id_str.length > 0) {
        arr = item.login_id_str.split(",");

        for (var j = 0; j < arr.length; j++) {
          list.push({ value: arr[j].toString(), text: arr[j].toString() });
        }
      } else {
        list.push({ value: null, text: null });
      }

      for (var j = 0; j < freeList.length; j++) {
        list.push({ value: freeList[j].login_id.toString(), text: freeList[j].login_id.toString() });
      }

      return list;
    },
    changedLoginId: function(info, eventStatus, orgvalue) {
      this.$helpers
        .alert({
          title: this.$t("ui.login_id"),
          text: this.$t("message.change_login_id_confirm", { name: info.bot_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmLoginId(info, eventStatus);
          } else {
            $("." + info.bot_id).val(orgvalue);
            // info.login_id = orgvalue.toString();
          }
        });
    },
    confirmLoginId: function(info, value) {
      let url = config.updateBotLoginUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.bot,
        bot_id: info.bot_id,
        loginData: []
      };

      json.loginData.push({
        bot_id: info.bot_id,
        login_id: value
      });

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getBotList();
                this.$snotify.success(this.$t("message.success"));
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onEdit(e) {
      this.editSelectedId = e.bot_id;
      this.editSelectedName = e.bot_name;
      this.editSelectedProviderID = e.provider_id;
      this.editSelectedRemark = e.remark;
      this.$refs.editbot.$refs.editBot.show();
    },
    onDelete(e) {
      this.deleteSelectedId = e.bot_id;
      this.deleteSelectedName = e.bot_name;
      this.deleteSelectedProviderID = e.provider_id;
      this.$refs.deletebot.$refs.deleteBot.show();
    },
    onAssignLogin(e) {
      this.editSelectedId = e.bot_id;
      this.editSelectedProviderID = e.provider_id;
      this.$refs.assignbotlogin.$refs.assignBotLogin.show();
    },
    onAssignProxy(e) {
      this.editSelectedId = e.bot_id;
      this.editSelectedProviderID = e.provider_id;
      this.$refs.assignbotproxy.$refs.assignBotProxy.show();
    },
    addBot: function(botId, botName, providerID, remark) {
      let newBot = {
        bot_id: botId,
        provider_id: providerID.toUpperCase(),
        bot_name: botName,
        time_sync: 0,
        remark: remark,
        created_on: new Date()
      };

      this.botSearch = "";
      this.getBotList();
      //this.botList.unshift(newBot);
      this.$helpers.showDialog(this.$t("ui.combine.add_bot"), this.$t("message.success"), "success");
    },
    assignBotLogin: function(botId, botName) {
      this.getBotList();
      this.$helpers.showDialog(this.$t("ui.combine.assign_bot_login"), this.$t("message.success"), "success");
    },
    assignBotProxy: function(botId, botName) {
      this.getBotList();
      this.$helpers.showDialog(this.$t("ui.combine.assign_bot_login"), this.$t("message.success"), "success");
    },
    vipBotLogin: function() {
      this.getBotList();
      this.$helpers.showDialog(this.$t("ui.combine.vip_bot_login"), this.$t("message.success"), "success");
    },
    editBot: function(botId, botName, providerID, remark) {
      this.botList.filter(function(botInfo) {
        if (botInfo.bot_id == botId) {
          botInfo.provider_id = providerID;
          botInfo.bot_name = botName;
          botInfo.remark = remark;
        }
      });
      this.$helpers.showDialog(this.$t("ui.combine.edit_bot"), this.$t("message.success"), "success");
    },
    deleteBot: function(botId) {
      let i = this.botList
        .map(botInfo => {
          return botInfo.bot_id;
        })
        .indexOf(botId);
      this.botList.splice(i, 1);
      this.$helpers.showDialog(this.$t("ui.combine.delete_bot"), this.$t("message.success"), "success");
    },
    changedDisable: function(disabled, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.disabled"),
          text: this.$t("message.change_disable_confirm", { name: disabled.bot_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDisable(disabled, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !disabled.bot_disabled;
          }
        });
    },
    confirmDisable: function(disabled, status) {
      let url = config.editBotDisabledUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.bot,
        bot_id: disabled.bot_id,
        bot_disabled: status
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                disabled.bot_disabled = status;
                this.$helpers.showDialog(this.$t("ui.disabled"), this.$t("message.success"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedTimeSync: function(timeSync, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.time_sync"),
          text: this.$t("message.change_time_sync_confirm", { name: timeSync.bot_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmTimeSync(timeSync, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = timeSync.time_sync;
          }
        });
    },
    confirmTimeSync: function(timeSync, seconds) {
      let url = config.updateBotTimeSyncUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.bot,
        bot_id: timeSync.bot_id,
        time_sync: seconds
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                timeSync.time_sync = seconds;
                this.$helpers.showDialog(this.$t("ui.time_sync"), this.$t("message.success"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
